// extracted by mini-css-extract-plugin
module.exports = {"orderDetail":"jl","orderDetailHeader":"kl","accountHeader":"ll","backNav":"ml","orderInfo":"nl","paymentUpdateSuccess":"ol","orderDate":"pl","orderId":"ql"};